module.exports = new __parcel__URL__("next-gen-board-app-skeleton.tpl.d10f8ca5.svg").toString();